import { render, staticRenderFns } from "./UsuariosRegiaoAdmin.vue?vue&type=template&id=9d63cd16&"
import script from "./UsuariosRegiaoAdmin.vue?vue&type=script&lang=js&"
export * from "./UsuariosRegiaoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports